/**
 * Informations de l'entreprise affichées dans le pied de page des emails.
 * Les champs vides ne s'affichent pas : il suffit de les remplir ici quand les infos réelles seront disponibles.
 */
export const COMPANY_INFO = {
  name: "Kafintech Group INC",
  /** Ex: "2120, Av Victoria #180, Longueuil, QC J4V 1M9, Canada" */
  address: "",
  /** Mentions réglementaires, une ligne par entrée. Ex: "Enregistrée auprès de CANAFE — N° M00000000" */
  registrations: [] as string[],
  phone: "",
  email: "",
  website: "",
  privacyUrl: "",
  socials: [
    {
      name: "Facebook",
      url: "https://www.facebook.com/izilifepay",
      icon: "https://cdn.simpleicons.org/facebook/1683E6.png",
    },
    { name: "X", url: "https://twitter.com/izilifepay", icon: "https://cdn.simpleicons.org/x/1683E6.png" },
    {
      name: "Instagram",
      url: "https://www.instagram.com/izilifepay",
      icon: "https://cdn.simpleicons.org/instagram/1683E6.png",
    },
    {
      name: "TikTok",
      url: "https://www.tiktok.com/@izilifepay",
      icon: "https://cdn.simpleicons.org/tiktok/1683E6.png",
    },
    {
      name: "YouTube",
      url: "https://www.youtube.com/c/izilifepay",
      icon: "https://cdn.simpleicons.org/youtube/1683E6.png",
    },
  ],
};
